/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import {
  API_DATE_FORMAT,
  MOMENT_DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
} from '../../shared/constants/Constants';
import { getFlightTicketApi, requestRescheduleApi } from '../../api/flightApi';
import { getUserAgentId } from '../../shared/helper-utils/localStorage';
import {
  formatDate,
  formatTimeString,
  getNewDate,
  getNewDateDisplayFormat,
  isEmpty,
} from '../../shared/helper-utils/appUtils';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import AppButton from '../../shared/components/app-button/AppButton';

function FlightResheduleRequestPageOfline() {
  const { transactionId } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const flightTransactionRef = useRef(undefined);
  const flightRecordRef = useRef(undefined);
  const bookingInfoRef = useRef({});
  const flightSectorsRef = useRef(null);
  const passengerRef = useRef(null);
  const fareSummaryRef = useRef({});
  const [passengers, setPassengers] = useState({});
  const [hasTicket, setHasTicket] = useState(undefined);
  const onwardPaxRef = useRef([]);
  const returnPaxRef = useRef([]);
  const [selectedForCancel, setSelectedForCancel] = useState([]);
  const [rescheduleRemarks, setRescheduleRemarks] = useState('');
  const [requesterName, setRequesterName] = useState('');
  const [requestContactNumber, setRequestContactNumber] = useState('');
  const [showConfirmReschedulePopup, setShowConfirmReschedulePopup] =
    useState(false);
  const [onwardResheduleDate, setOnwardResheduleDate] = useState('');
  const [returnResheduleDate, setreturnResheduleDate] = useState('');

  const getFlightTicketRoute = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_TICKET_PAGE;
    route = route.replace(':transactionId', txid);
    return route;
  };

  const setFareSummary = (data) => {
    const fareDetails = data.FlightRecord.FareDetails.split('##').map(Number);
    [fareSummaryRef.current.basefare, fareSummaryRef.current.totaltaxes] =
      fareDetails;
    fareSummaryRef.current.gst = fareDetails[3];
    const ssrAmount = data.FlightRecord.SSRAmount;
    const totalAmount =
      fareDetails[0] + fareDetails[1] + fareDetails[3] + ssrAmount;
    fareSummaryRef.current.invoicetotal = totalAmount;
    fareSummaryRef.current.ssr = ssrAmount;
  };

  const getData = async () => {
    setIsLoading(true);
    const response = await getFlightTicketApi(transactionId, getUserAgentId());
    if (response) {
      const { FlightInvoice } = response.ApiStatus.Result.FullFlightDetails;
      flightTransactionRef.current = FlightInvoice;
      flightRecordRef.current = FlightInvoice.FlightRecord;
      bookingInfoRef.current = {
        AirlinePnr: FlightInvoice.FlightRecord.AirlinePnr,
        BookingStatus: FlightInvoice.FlightRecord.BookingStatus,
        Origin: FlightInvoice.FlightRecord.Origin,
        Destination: FlightInvoice.FlightRecord.Destination,
        Jtype: FlightInvoice.FlightRecord.JType.toLowerCase(),
      };
      let { SectorRecord } = FlightInvoice.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];

      const airportNames = {};
      SectorRecord.forEach((ele) => {
        airportNames[ele.Origin] = ele.OriginFullName;
        airportNames[ele.Destination] = ele.DestinationFullName;
      });
      flightSectorsRef.current = SectorRecord;

      let { PassengerRecord } = FlightInvoice.PassengerRecords;
      PassengerRecord = Array.isArray(PassengerRecord)
        ? PassengerRecord
        : [PassengerRecord];

      passengerRef.current = PassengerRecord;

      let onwardList = [];
      onwardList = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 1,
      );
      onwardPaxRef.current = onwardList;

      let returnList = [];
      returnList = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 2,
      );
      returnPaxRef.current = returnList;

      const list = { ...passengerRef.current };
      setPassengers(list);
      setFareSummary(FlightInvoice);
      setHasTicket(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [transactionId]);

  const handleCheckboxSelection = (pax) => {
    if (
      pax.Type.toLowerCase() === 'adult' ||
      pax.Type.toLowerCase() === 'infant'
    ) {
      const infantList = [];
      const adultList = [];
      if (pax.SegmentNumber === 1) {
        onwardPaxRef.current.forEach((passenger) => {
          if (passenger.Type.toLowerCase() === 'adult') {
            adultList.push(passenger.Paxid);
          }
          if (passenger.Type.toLowerCase() === 'infant') {
            infantList.push(passenger.Paxid);
          }
        });
      }
      if (pax.SegmentNumber === 2) {
        onwardPaxRef.current.forEach((passenger) => {
          if (passenger.Type.toLowerCase() === 'adult') {
            adultList.push(passenger.Paxid);
          }
          if (passenger.Type.toLowerCase() === 'infant') {
            infantList.push(passenger.Paxid);
          }
        });
      }
      if (infantList.length > 0) {
        const paxTobeSelected = [pax];
        if (pax.Type.toLowerCase() === 'infant') {
          const selectedIndex = infantList.indexOf(pax.Paxid);
          const paxAssociated = passengerRef.current.find(
            (px) => px.Paxid === adultList[selectedIndex],
          );
          if (paxAssociated) {
            paxTobeSelected.push(paxAssociated);
          }
        }
        if (pax.Type.toLowerCase() === 'adult') {
          const selectedIndex = adultList.indexOf(pax.Paxid);
          const paxAssociated = passengerRef.current.find(
            (px) => px.Paxid === infantList[selectedIndex],
          );
          if (paxAssociated) {
            paxTobeSelected.push(paxAssociated);
          }
        }
        let list = [...selectedForCancel];
        paxTobeSelected.forEach((x) => {
          if (list.some((item) => item.Paxid === x.Paxid)) {
            list = list.filter((p) => p.Paxid !== x.Paxid);
          } else {
            list.push(x);
          }
        });
        setSelectedForCancel(list);
        return;
      }
    }
    setSelectedForCancel((prevItems) => {
      if (prevItems.some((selectedPax) => selectedPax.Paxid === pax.Paxid)) {
        return prevItems.filter(
          (selectedPax) => selectedPax.Paxid !== pax.Paxid,
        );
      }
      return [...prevItems, pax];
    });
  };

  const isChecked = (id) => {
    const isPresent = selectedForCancel.some((x) => x.Paxid === id);
    if (isPresent) {
      return true;
    }
    return false;
  };

  const handleRaiseRescheduleRequest = async () => {
    setIsLoading(true);
    setShowConfirmReschedulePopup(false);
    const selectedPaxIds = [];
    const selectedPaxTypes = [];
    selectedForCancel.forEach((pax) => {
      const paxsegmentnum = pax.SegmentNumber === 1 ? 'Onward' : 'Return';
      selectedPaxIds.push(pax.Paxid);
      selectedPaxTypes.push(`${pax.Paxid}##${pax.Type}##${paxsegmentnum}`);
    });
    const paxIdsString = selectedPaxIds.join(':');
    const paxTypeString = selectedPaxTypes.join(':');
    const req = {
      contactname: requesterName,
      contactphone: requestContactNumber,
      agentid: getUserAgentId(),
      reftxid: transactionId,
      remarks: rescheduleRemarks,
      canxpax: paxIdsString,
      rescheduledate_onward: onwardResheduleDate,
      rescheduledate_return: returnResheduleDate,
      resc_paxinfo: paxTypeString,
    };
    const res = await requestRescheduleApi(req);
    if (res && res.Root && res.Root.Status === 'OK') {
      setAlert({
        variant: 'success',
        title: 'Reschedule Request',
        description: `${
          res?.Root?.Message ? res?.Root?.Message : ''
        } Redirecting to Home Page`,
      });
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } else {
      setAlert({
        variant: 'error',
        title: 'Reschedule Request',
        description: res?.Root?.Message || 'Failed to raise Request',
      });
    }
    setIsLoading(false);
  };

  const handleConfirmRescheduleRequest = () => {
    if (rescheduleRemarks === '') {
      setAlert({
        variant: 'error',
        title: 'Flight Reschedule',
        description: 'Please enter remarks',
      });
      return;
    }
    let onwardCount = 0;
    let returnCount = 0;
    selectedForCancel.forEach((pax) => {
      if (pax.SegmentNumber === 1) {
        onwardCount += 1;
      }
      if (pax.SegmentNumber === 2) {
        returnCount += 1;
      }
    });
    if (onwardCount > 0 && isEmpty(onwardResheduleDate)) {
      setAlert({
        variant: 'error',
        title: 'Reschedule Request',
        description: 'Please select Reschedule date',
      });
      return;
    }
    if (returnCount > 0 && isEmpty(returnResheduleDate)) {
      setAlert({
        variant: 'error',
        title: 'Reschedule Request',
        description: 'Please select Reschedule date for Return',
      });
      return;
    }
    setShowConfirmReschedulePopup(true);
  };

  return (
    <section className="flight-reshedule-page">
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      <AppLoading isLoading={isLoading} />

      {hasTicket !== undefined && hasTicket && (
        <div className="flight-reshedule-page_container">
          <div className="flight-details">
            <h4>Flight Details</h4>
            <div className="flight-details-table overflow-auto">
              <table cellSpacing="4" cellPadding="5" className="w-100">
                <tbody>
                  <tr>
                    <td>Airline PNR</td>
                    <td>{flightRecordRef.current.AirlinePnr.split(',')[0]}</td>
                    <td>Booking Date</td>
                    <td>{flightRecordRef.current.BookingDate}</td>
                  </tr>
                  <tr>
                    <td>Booking Id</td>
                    <td>
                      <a
                        href={getFlightTicketRoute(
                          flightRecordRef.current.Txid,
                        )}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {flightRecordRef.current.Txid}
                      </a>
                    </td>
                    <td>Passenger Contact</td>
                    <td>{flightRecordRef.current.PassengerContact}</td>
                  </tr>
                  <tr>
                    <td>Booking Status</td>
                    <td>{flightRecordRef.current.BookingStatus}</td>
                    <td>GDS PNR</td>
                    <td>{flightRecordRef.current.GdsPnr}</td>
                  </tr>
                </tbody>
              </table>
              <table className="w-100">
                <thead>
                  <tr>
                    <th>From - To</th>
                    <th>Flight</th>
                    <th>Departure Date</th>
                    <th>Departure</th>
                    <th>Arrival</th>
                  </tr>
                </thead>
                <tbody>
                  {flightSectorsRef.current.map((sector) => (
                    <React.Fragment
                      key={`${sector.Origin}:${sector.Destination}`}
                    >
                      <tr>
                        <td>
                          {sector.OriginFullName}({sector.Origin}) --&gt;{' '}
                          {sector.DestinationFullName}({sector.Destination})
                        </td>
                        <td>
                          {sector.Carrier} - {sector.FlightNumber}(class-
                          {sector.BookingClass})
                        </td>
                        <td>
                          {getNewDateDisplayFormat(
                            sector.JourneyDate,
                            MOMENT_DATE_MONTH_YEAR_VIEW_FORMAT,
                          )}
                        </td>
                        <td>{formatTimeString(sector.DepartureTime)}</td>
                        <td>{formatTimeString(sector.ArrivalTime)}</td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
              <table className="w-100">
                <thead>
                  <tr>
                    <th>Fare</th>
                    <th>Tax</th>
                    <th>SSR</th>
                    <th>GST</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {fareSummaryRef.current.basefare !== null &&
                        fareSummaryRef.current.basefare.toFixed(2)}
                    </td>
                    <td>{fareSummaryRef.current.totaltaxes.toFixed(2)}</td>
                    <td>{fareSummaryRef.current.ssr.toFixed(2)}</td>
                    <td>{fareSummaryRef.current.gst.toFixed(2)}</td>
                    <td>{fareSummaryRef.current.invoicetotal.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
              <h6>Ticket Details</h6>
              <table className="w-100">
                <thead>
                  <tr>
                    <th>Tx.Id</th>
                    <th>Journey Type</th>
                    <th>Booking Date</th>
                    <th>Agent ID</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{flightRecordRef.current.Txid}</td>
                    <td>{flightRecordRef.current.JType}</td>
                    <td>{flightRecordRef.current.BookingDate}</td>
                    <td>
                      {flightRecordRef.current.AgentCompany}(
                      {flightRecordRef.current.AgentId})
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="cancel-pax_table p-3">
            {onwardPaxRef.current.length > 0 && (
              <div className="d-flex flex-column align-items-start">
                <span className="cancel-pax_sector-heading">
                  Select Passengers For Reschedule - Onward Journey. (
                  {flightRecordRef.current.Origin}-
                  {flightRecordRef.current.Destination})
                </span>
                <div className="d-flex flex-column m-2 fs-14 fw-500">
                  {onwardPaxRef.current.map((pax) => (
                    <div key={pax.Paxid} className="d-flex gap-2 my-1">
                      <span>
                        {pax.Status === 'confirmed' ? (
                          <input
                            type="checkbox"
                            name={pax.Paxid}
                            value={pax.Paxid}
                            checked={isChecked(pax.Paxid)}
                            onChange={() => handleCheckboxSelection(pax)}
                          />
                        ) : (
                          '-'
                        )}
                      </span>
                      <span>
                        {pax.Title} {pax.FirstName} {pax.LastName}({pax.Type})
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {returnPaxRef.current.length > 0 && (
              <div className="mt-2 d-flex flex-column align-items-start">
                <span className="cancel-pax_sector-heading">
                  Select Passengers For Reschedule - Return Journey. (
                  {flightRecordRef.current.Destination}-
                  {flightRecordRef.current.Origin})
                </span>
                <div className="d-flex flex-column m-2 fs-14 fw-500">
                  {returnPaxRef.current.map((pax) => (
                    <div key={pax.Paxid} className="d-flex gap-2 my-1">
                      <span>
                        {pax.Status === 'confirmed' ? (
                          <input
                            type="checkbox"
                            name={pax.Paxid}
                            value={pax.Paxid}
                            checked={isChecked(pax.Paxid)}
                            onChange={() => handleCheckboxSelection(pax)}
                          />
                        ) : (
                          '-'
                        )}
                      </span>
                      <span>
                        {pax.Title} {pax.FirstName} {pax.LastName}({pax.Type})
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className="mt-2 d-flex flex-column align-items-start">
              <span className="cancel-pax_sector-heading">
                Reschedule Details
              </span>
            </div>
            <div className="m-2 d-flex flex-column align-items-start gap-2">
              <AppDatePicker
                label="Reschedule Onward date"
                name="onwardResheduleDate"
                className="app-date-picker"
                customClassName="position-relative flight-booking-picker "
                placeholder=""
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                disabledKeyboardNavigation
                minDate={getNewDate(TODAY_DATE)}
                selectedDate={
                  !isEmpty(onwardResheduleDate) &&
                  getNewDate(onwardResheduleDate)
                }
                onChange={(date) => {
                  setOnwardResheduleDate(
                    formatDate(getNewDate(date), API_DATE_FORMAT),
                  );
                  setreturnResheduleDate('');
                }}
                labelClassName="booking-date-label"
              />
              {flightRecordRef.current.JType.toLowerCase() === 'roundtrip' && (
                <AppDatePicker
                  label="Reschedule Return date"
                  name="onwardResheduleDate"
                  className="app-date-picker"
                  customClassName="position-relative flight-booking-picker "
                  placeholder=""
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  disabledKeyboardNavigation
                  minDate={
                    isEmpty(onwardResheduleDate)
                      ? getNewDate(TODAY_DATE)
                      : getNewDate(onwardResheduleDate)
                  }
                  selectedDate={
                    !isEmpty(returnResheduleDate) &&
                    getNewDate(returnResheduleDate)
                  }
                  onChange={(date) =>
                    setreturnResheduleDate(
                      formatDate(getNewDate(date), API_DATE_FORMAT),
                    )
                  }
                  labelClassName="booking-date-label"
                />
              )}
              <AppTextInput
                value={requesterName}
                label="Requester Name"
                onChange={(e) => setRequesterName(e.target.value)}
              />
              <AppNumberInput
                value={requestContactNumber}
                label="Contact Number"
                onChange={(d) => setRequestContactNumber(d)}
              />
              <AppTextInput
                value={rescheduleRemarks}
                label="Remarks"
                onChange={(e) => setRescheduleRemarks(e.target.value)}
              />
              <AppButton
                onClick={handleConfirmRescheduleRequest}
                disabled={selectedForCancel.length === 0}
                className="px-5"
                variant="outlined"
                btnText="Request Reschedule"
              />
            </div>
          </div>
          <Modal
            className="app-modal"
            show={showConfirmReschedulePopup}
            size="md"
            backdrop="static"
            keyboard={false}
            onHide={() => setShowConfirmReschedulePopup(false)}
          >
            <Modal.Body className="cancel-flight-body">
              <div className="cancel-flight-body__cancel-title">
                Are you sure, you want to raise Reschedule request?
              </div>
              <div className="d-flex mt-2">
                <AppButton
                  className="flex-1 me-2"
                  btnText="Yes"
                  onClick={handleRaiseRescheduleRequest}
                />
                <AppButton
                  className="flex-1 ms-2"
                  btnText="No"
                  variant="outlined"
                  onClick={() => setShowConfirmReschedulePopup(false)}
                />
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </section>
  );
}

export default FlightResheduleRequestPageOfline;
